import styled from 'styled-components'

export const LlmConversationConfirmationBannerStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${(props) => props.theme.typography.pxToRem(16)};

  width: 100%;
  padding: ${(props) => props.theme.typography.pxToRem(16)};

  background-color: ${(props) => props.theme.colors.alert.ai.background};
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
`
